import { message } from 'antd';

export const copyToClipboard = (
  text: string,
  notification: string = 'данные скопированы в буфер обмена',
) => {
  if (text) {
    navigator.clipboard.writeText(text);
    message.success(notification);
  }
};
